module.exports = __webpack_public_path__ + "static/media/signage-industrial-img23.f6ce20f8.jpg";